import React from 'react';
import { bool, func, number, string } from 'prop-types';
import { Button, Box, IconButton, Tooltip } from '@mui/material';
import DeleteOutlineRounded from '@mui/icons-material/DeleteOutlineRounded';

import { Chip, CopyButton, InputField } from '../../../../../../../../components';
import PermissionGate from '../../../../../../../../components/PermissionGate';
import staticText from '../../../../../../../../localization/Application/Configuration/configuration';

const RedirectUri = ({
  redirectUri, removeRedirectUri, index, isDefault, setDefaultRedirectUri,
}) => {
  const uriInput = (
    <InputField
      inputName={`redirectUri-${index}`}
      inputValues={redirectUri}
      inputDisabled
      showActionsOnHover
      chip={isDefault ? (
        <Chip
          label={staticText.oauth.redirectUris.default}
          type="status"
          variant="outlined"
        />
      ) : null}
      actions={(
        <Box display="flex" alignItems="center" gap={1}>
          <CopyButton content={redirectUri} />
          <PermissionGate dashboardPermission="write_configuration">
            <IconButton
              id={`delete-uri-${index}`}
              aria-label={staticText.oauth.redirectUris.delete}
              name="delete-uri"
              onClick={() => removeRedirectUri(redirectUri)}
            >
              <DeleteOutlineRounded />
            </IconButton>
            {setDefaultRedirectUri && (
              <Button
                variant="outlined"
                color="secondary"
                onClick={() => setDefaultRedirectUri(redirectUri)}
                disabled={isDefault}
              >
                {staticText.oauth.redirectUris.setAsDefault}
              </Button>
            )}
          </PermissionGate>
        </Box>
      )}
    />
  );

  return (
    <Box marginBottom={1} width="max-content">
      {redirectUri.length > 50 ? (
        <Tooltip title={redirectUri} placement="top" arrow>
          <span>{uriInput}</span>
        </Tooltip>
      ) : (
        uriInput
      )}
    </Box>
  );
};

RedirectUri.propTypes = {
  redirectUri: string.isRequired,
  removeRedirectUri: func.isRequired,
  index: number.isRequired,
  isDefault: bool,
  setDefaultRedirectUri: func,
};

RedirectUri.defaultProps = {
  isDefault: false,
  setDefaultRedirectUri: null,
};

export default RedirectUri;
